// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__0F0y5"};